import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=5f25c341&"
import script from "./confirmation.component.ts?vue&type=script&lang=ts&"
export * from "./confirmation.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports